import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import Widget from "views/logic/widgets/Widget";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import Series from "views/logic/aggregationbuilder/Series";
import TitleTypes from "views/stores/TitleTypes";
import { addWidget } from "views/logic/slices/widgetActions";
import { setTitle } from "views/logic/slices/titlesActions";
import { selectActiveQuery } from "views/logic/slices/viewSelectors";
import duplicateCommonWidgetSettings from "./DuplicateCommonWidgetSettings";
const NUMERIC_FIELD_SERIES = ["count", "sum", "avg", "min", "max", "stddev", "variance", "card", "percentile"];
const NONNUMERIC_FIELD_SERIES = ["count", "card"];
const handler = ({ field, type, contexts: { widget: origWidget = Widget.empty() } }) => (dispatch, getState) => {
  const activeQuery = selectActiveQuery(getState());
  const series = (type && type.isNumeric() ? NUMERIC_FIELD_SERIES : NONNUMERIC_FIELD_SERIES).map((f) => {
    if (f === "percentile") {
      return `${f}(${field},95)`;
    }
    return `${f}(${field})`;
  }).map(Series.forFunction);
  const config = AggregationWidgetConfig.builder().series(series).visualization("table").rollup(true).build();
  const widgetBuilder = AggregationWidget.builder().newId().config(config);
  const widget = duplicateCommonWidgetSettings(widgetBuilder, origWidget).build();
  return dispatch(addWidget(widget)).then(
    () => dispatch(setTitle(activeQuery, TitleTypes.Widget, widget.id, `Field Statistics for ${field}`))
  );
};
export default handler;
